















































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { EventBus } from '.././event-bus';
import axios from 'axios';
import DefaultPath from '@/helpers/default.path';

@Component
export default class Nav extends Vue {
  
  impersonateOrganizations: any = [];

  private async created() {
    //@ts-ignore
    const self = this;
    await axios
      .get('/Dictionary/GetImpersonateOrganizations')
      .then((response) => {
        self.impersonateOrganizations = response.data;
      })
      .catch(() => {});

    EventBus.$on('logged-in', (payLoad: any) => {
      console.log('logged-in message received...');
    });
  }

  isActive(name: string) {
    return this.$route.name === name;
  }
  private destroyed() {
    EventBus.$off('logged-in');
  }

  get currentOrganization() {
      return this.$auth.user().impersonateOrganizations.find((io: any) => io.key == this.$auth.user().currentOrganization.id);
  }

  get fullName() {
    return this.$auth.user().login + ', ' + this.$auth.user().name.split(/\s+/).map((w : any,i : any) => i ? w.substring(0,1).toUpperCase() + '.' : w).join(' ');
  }

  get donorFormDefaultStatus() {
    if (this.$auth.user().isDoctor) {
      return 3;
    }
    if (this.$auth.user().isLab) {
      return 2;
    }
    return '';
  }

  changeOrganization(event: any) {
    let organizationId = event.key;
    let currentRouteName = this.$route.name;
    axios
      .get('/users/ChangeImpersonateOrganization/' + organizationId)
      .then(async (response) => {
        await this.$auth.fetchUser();
        let path = DefaultPath.getRedirectPath(this.$auth.user(), currentRouteName, /^RDKM/.test(event.value) ? null : organizationId);
        this.$router.push({
          path: path,
        });
        this.$router.go(0);
      })
      .catch((error) => {
        EventBus.$emit('error', { msg: error.data });
      });
  }
}
